module.exports = __webpack_public_path__ + "img/4.020f726d.svg";